function SetDropdownDefaultValue(options, value) {
  if(value) {
    return options.filter(obj => {
      return obj.value === value
    })[0]
  }
  return null;
}

export default SetDropdownDefaultValue;